import sendToServer from './send-to-server';

const Vacancies = {
  init() {
    if ($('.vacancies').length !== 1) return;
    $('.standard-vacancy').click(this.handleVacancyClick.bind(this));

    if (!$('.vacancies').data('journalise')) return;
    $('.journaliser').click(this.handleJournaliserClick.bind(this));

    this.checkJournalised();
  },

  checkJournalised() {
    const journalVacancies = $('.vacancies').data('journal-vacancies');

    $('.vacancy').each((_, element) => {
      const vacancy = $(element);
      const url = vacancy.prop('href')
      if (journalVacancies.find(x => x.url === url)) {
        vacancy.find('.journaliser').addClass('added');
      }
    });
  },

  handleJournaliserClick(event) {
    event.preventDefault();
    const journaliser = $(event.target).closest('.journaliser');
    if (journaliser.hasClass('added')) return;
    journaliser.addClass('added');
    const vacancy = journaliser.closest('.vacancy');

    const journalVacancies = $('.vacancies').data('journal-vacancies');

    const newVacancy = {
      url: vacancy.prop('href'),
      career_id: $('.vacancies').data('career-id'),
      title: vacancy.find('.vacancy-title').text(),
      company: vacancy.find('.vacancy-company').text(),
    }

    journalVacancies.push(newVacancy);

    sendToServer('/api/v2/journal',
                 { vacancies: journalVacancies },
                 null,
                 'PATCH');
  },

  handleVacancyClick() {
    sendToServer('/api/v2/events/',
                 { event: 'viewed_vacancy',
                   career_id: $('.vacancies').data('career-id')});
  }
}

$(document).ready(()=> {
  Vacancies.init();
});
